var map = {
	"./desklamp.png": "0291",
	"./dishwasher.png": "e969",
	"./dock.png": "4b8d",
	"./dryer.png": "f407",
	"./fridge.png": "9151",
	"./han.png": "25bf",
	"./keyboard.png": "5509",
	"./lightswitch.png": "a986",
	"./nest.png": "cde0",
	"./pc.png": "c032",
	"./tablet.png": "ccd4",
	"./washer.png": "b36d",
	"./xbox.png": "5b96"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e106";